import state from './moduleInstanceState'
import actions from './moduleInstanceActions'
import getters from './moduleInstanceGetters'
import mutations from './moduleInstanceMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
